import React from "react";
import { ButtonProps, Button } from "antd";
import { classNames as cn } from "@features/utils/reactFunctions";

import * as style from "./CustomBtnStyle.module.scss"

interface Props extends ButtonProps {
  children: React.ReactNode;
  myType: "submit" | "cancel";
}

const CustomBtn = ({
  children,
  myType,
  className: classNameProp,
  ...rest
}: Props) => {
  let className;
  switch (myType) {
    case "submit":
      className = style.submit;
      break;
    case "cancel":      
      break;
    default:
      className = "";
  }

  return (
    <Button {...rest} className={cn(style.btn, className, classNameProp)}>
      {children}
    </Button>
  );
};

export default CustomBtn;
